import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

// Register necessary components
ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = (props) => {
  const { labels = [], resource = [] } = props
  const data = {
    labels: labels,
    datasets: [
      {
        label: "Nbr de commandes",
        data: resource,
        backgroundColor: [
          '#848482', '#57FEFF', '#008000', '#1E90FF'
        ],
        borderColor: [
          '#848482', '#57FEFF', '#008000', '#1E90FF'
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'right',
      },
      tooltip: {
        enabled: true,
      },
      title: {
        display: true,
        text: 'Statistiques des produit',
      },
    },
  };

  return <Pie data={data} options={options} />;
};

export default PieChart;
